"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "presenterSettingsSource", {
  enumerable: true,
  get: function get() {
    return _presenterSettingsSource["default"];
  }
});
var _presenterSettingsSource = _interopRequireDefault(require("./presenterSettingsSource"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }